export const PriceListColumns =[
    "Year",
    "Season",
    "Item",
    "Sample_Code",
    "Business",
    "FOBLocal_Currency",
    "Currency"
]